/* jshint esversion: 6 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Layout from "@/components/layout/index";

export default new Router({
  routes: [
    {
      path: '/',
      redirect:"/home",
      component:Layout,
      meta:{
        isShowNav:true
      },
      children:[{
        path: '/home',
        name: 'home',
        component:()=>
          import('@/views/homepage/index'),
        meta:{
          title:"网站首页"
        }
      },{
        path: '/productCenter',
        name: 'productCenter',
        component:()=>
          import('@/views/productCenter/index'),
        meta:{
          title:"产品中心"
        }
      },{
        path: '/case',
        name: 'case',
        component:()=>
          import('@/views/case/index'),
        meta:{
          title:"典型案例"
        }
      },{
        path: '/news',
        name: '                                                                                                                                  ',
        component:()=>
          import('@/views/news/index'),
        meta:{
          title:"新闻动态"
        }
      },{
        path: '/aboutUs',
        name: 'aboutUs',
        component:()=>
          import('@/views/aboutUs/index'),
        meta:{
          title:"关于我们"
        }
      },{
        path: '/joinUs',
        name: 'joinUs',
        component:()=>
          import('@/views/joinUs/index'),
        meta:{
          title:"加入我们"
        }
      }]
    },{
      path: '/error',

      component:()=>
          import('@/views/error/index'),
      meta:{
        isShowNav:false,
        title:"404"
      }
    },{
      path: '/contactUs',
      name: 'contactUs',
      component:Layout,
      redirect:"/contactUsIndex",
      meta:{
        title:"联系我们"
      },
      children:[{
        path: '/contactUsIndex',
        component:()=>
            import('@/views/contactUs/index'),
        meta:{
          title:"联系我们"
        },
      }]
    },{
      path: '/listContent',
      name: 'listContent',
      component:Layout,
      meta:{
        isShowNav:false,
        title:"稿件详情"
      },
      children:[{
        path: '/listContent',
        name: 'listContent',
        component:()=>
          import('@/views/listContent/index'),
        meta:{
          isShowNav:false,
          title:"稿件详情"
        },
      },{
        path: '/productContent',
        name: 'productContent',
        component:()=>
          import('@/views/listContent/productContent'),
        meta:{
          isShowNav:false,
          title:"稿件详情"
        },
      }]
    },{
      path: '/browserPage',
      component:Layout,
      redirect:"/browserPageIndex",
      meta:{
        isShowNav:false
      },
      children:[{
        path: '/browserPageIndex',
        component:()=>
            import('@/views/browserPage/index'),
      }]
    },{
      path: '/searchPage',
      component:()=>
          import('@/views/searchPage/index'),
      meta:{
        isShowNav:false
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js